import React from 'react'
import Select, { ActionMeta, OnChangeValue, StylesConfig, components, DropdownIndicatorProps, GroupBase, MultiValue } from 'react-select';


import { OptionTypes } from '../../types/types';
import { FormikContextType } from 'formik';

interface MultiSelectProp {
  heightControlSection?: string,
  isSearchable?: boolean,
  disabled?:boolean,
  options: OptionTypes[],
  borderColor?: string,
  setOptionSelected?: (option:MultiValue<OptionTypes>) => void,
  setSelectSearch?: (input: string) => void,
  isLoading?: boolean
  formik?: FormikContextType<any>
  fieldName: string
  placeholder?: string
  className?: string
  value?: MultiValue<OptionTypes> | null
  isClearable?: boolean,
  onChange?: (option: MultiValue<OptionTypes>) => void
  isNotFilter?:boolean
}


const MultiSelectComponent = (p: MultiSelectProp) => {
  
  const customStylesMultiSelect = {

    dropdownIndicator: (base, state) => ({
      ...base,
      color: 'var(--primary)',
      opacity: state.isDisabled ? 0.5 : 1,
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
      cursor: 'pointer',
      '&:hover': {
        color: 'var(--primary)'
      }
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      color: "var(--black)",
      boxShadow: 'none',
      backgroundColor: "var(--white)",
      width: "auto",
      fontWeight: "400",
      fontSize: "16px",
      borderRadius: "3px",
      lineHeight: "22px",
      position: "relative",
      border: 'border: 1px solid black',
  
      "&:hover": {
        color: "var(--black)",
        border: '1px solid black !important'
      },
      "&:active": {
        border: '1px solid black !important'
      },
      "&:": {
        border: '1px solid black !important'
      },
  
      "&:focus": {
        border: "1px solid black !important"
      },
      "&:focus-visible": {
       border: "1px solid black !important"
     },
     "&:focus-within": {
       border: "1px solid black !important"
     }
    }),
    menu: () => ({
      width: '100%',
      position: 'absolute',
      border: '1px solid black',
      borderRadius: '3px',
      zIndex: 1
    }),
    menuList: (provided) => ({
     ...provided,
     maxHeight: "150px"
   }),
  input: (provided, state) => ({
    ...provided,
  }),
  container: (provided, state) => ({
    ...provided,
    border: "none",
    opacity: p.disabled ? 0.3 : 1
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    padding: "0 0 0 10px",
    margin: 0,
    color: "white",
  }),
  multiValue:(provided, state) => ({
      ...provided,
      backgroundColor:"var(--primary) !important" ,
      color:"white !important"
  }),
  multiValueLabel:(provided, state) => ({
      ...provided,
      color:"white !important"
  }),
  option: (provided, state) => {
    const optionStyle = {
      ...provided,
      lineHeight: '22px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
      backgroundColor: state.isSelected ? "var(--primary)" : "white",
      cursor: "pointer",
      borderRadius: '3px',
      // height: '9vh',
      // fontWeight: '800',
  
      "&:hover": {
        backgroundColor: "var(--primary)",
        color: state.isSelected ? "black" : "white"
      },
  
      ":active": {
        backgroundColor: "var(--primary)",
        color: 'black'
      }
    }
    return optionStyle
  },
  singleValue: (provided, state) => ({
    ...provided,
    color: "white",
    padding: "0px"
  })
  } as StylesConfig;
  
  const customStylesMulti = {

    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: 'var(--primary)',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
      cursor: 'pointer',
      opacity: p.disabled ? 0 : 1,
      '&:hover': {
        color: 'var(--primary)'
      }
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    
    color: "var(--black)",
    boxShadow: 'none',
    backgroundColor: state.isFocused ? "white !important" : "white",
    border: state.isFocused ? '1px solid black' : `${p.borderColor ? p.borderColor : '1px solid black'}`,
    cursor: 'text',
    width: "100%",
    fontWeight: "400",
    fontSize: "16px",
    borderRadius: "3px",
    position: "relative",
    lineHeight: "22px",
    height: "100%",


    "&:hover": {
      color: "var(--black)"
    },
  }),
  menu: (baseStyles, state) => ({
    ...baseStyles,
    width: '100%',
    position: 'absolute',
    border: '1px solid var(--black)',
    borderRadius: '3px'
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "250px"
  }),
  input: (provided, state) => ({
    ...provided,
  }),
  container: (provided, state) => ({
    ...provided,
    border: "none",
    opacity: p.disabled ? 0.3 : 1
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    padding: "0 0 0 10px",
    margin: 0,
    color: "white",
  }),
  multiValue:(provided, state) => ({
      ...provided,
      backgroundColor:"var(--primary) !important" ,
      color:"white !important"
  }),
  multiValueLabel:(provided, state) => ({
      ...provided,
      color:"white !important"
  }),
  option: (provided, state) => {
    const optionStyle = {
      ...provided,
      lineHeight: '22px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
      backgroundColor: state.isSelected ? "var(--primary)" : "white",
      cursor: "pointer",
      borderRadius: '3px',
      // height: '9vh',
      // fontWeight: '800',

      "&:hover": {
        backgroundColor: "var(--primary)",
        color: state.isSelected ? "black" : "white"
      },

      ":active": {
        backgroundColor: "var(--primary)",
        color: 'black'
      }
    }
    return optionStyle
  },
  singleValue: (provided, state) => ({
    ...provided,
    color: "white",
    padding: "0px"
  })
} as StylesConfig;

  const onchange = (option:MultiValue<OptionTypes>,  actionMeta: ActionMeta<OptionTypes>) =>{
     p.setOptionSelected?.(option)
    }


  return (
    <Select
      {...p.formik?.getFieldProps(p.fieldName)}
      name={p.fieldName}
      options={p.options}
      isMulti
      isDisabled={p.disabled}
      captureMenuScroll={true}
      placeholder={p.placeholder}
      styles={p.isNotFilter ? customStylesMultiSelect as StylesConfig<OptionTypes> : customStylesMulti as StylesConfig<OptionTypes>}
      isSearchable={p.isSearchable ? true : false}
      components={{ IndicatorSeparator: () => null }}
      onChange={onchange}
      onBlur={() => p.formik?.setFieldTouched(p.fieldName, true)}
      isClearable={p.isClearable ? true : false}
      isLoading={p.isLoading}
      onInputChange={(input) => p.setSelectSearch?.(input as string)}
      className={p.className ?? ""}
      value={p.value}
    />
  )

  // sintassi componente
  // const [selectedOption, setSelectedOption] = useState<OptionTypes>({ id: '', value: '', label: '' })
  //  const [selectSearch, setSelectSearch] = useState('')
  //const debounceSelectSearch = useDebounce(selectSearch, 1000)
  // const [isLoading, setIsLoading] = useState(false)
  // <SelectComponent isLoading={isLoading} setSelectSearch={setSelectSearch} setOptionSelected={setSelectedOption} options={[{ id: 'dsacd', value: 'dsavdsav', label: 'dsavdsav' }]} borderColor={'1px solid var(--primary)'} isSearchable></SelectComponent>
}

export default MultiSelectComponent
